// skillsData.js
import {
  FaNodeJs,
  FaDocker,
  FaAws,
  FaHtml5,
  FaCss3Alt,
  FaReact,
} from "react-icons/fa";
import {
  SiNestjs,
  SiPostgresql,
  SiMongodb,
  SiRedis,
  SiRabbitmq,
  SiKubernetes,
  SiPostman,
  SiJavascript,
  SiFigma,
  SiAdobephotoshop,
  SiCanva,
} from "react-icons/si";

export const skills = {
  backend: [
    { name: "Node.js", icon: FaNodeJs, color: "text-green-400" },
    { name: "NestJS", icon: SiNestjs, color: "text-pink-500" },
    { name: "PostgreSQL", icon: SiPostgresql, color: "text-blue-400" },
    { name: "MongoDB", icon: SiMongodb, color: "text-green-500" },
    { name: "Redis", icon: SiRedis, color: "text-red-500" },
    { name: "Docker", icon: FaDocker, color: "text-sky-400" },
    { name: "Kubernetes", icon: SiKubernetes, color: "text-blue-500" },
    { name: "AWS", icon: FaAws, color: "text-yellow-400" },
    { name: "RabbitMQ", icon: SiRabbitmq, color: "text-orange-500" },
    { name: "Postman", icon: SiPostman, color: "text-orange-400" },
  ],
  frontend: [
    { name: "HTML", icon: FaHtml5, color: "text-orange-500" },
    { name: "CSS", icon: FaCss3Alt, color: "text-blue-500" },
    { name: "JavaScript", icon: SiJavascript, color: "text-yellow-400" },
    { name: "React", icon: FaReact, color: "text-cyan-400" },
  ],
  design: [
    { name: "Figma", icon: SiFigma, color: "text-purple-400" },
    { name: "Photoshop", icon: SiAdobephotoshop, color: "text-blue-600" },
    { name: "Canva", icon: SiCanva, color: "text-cyan-500" },
  ],
};
